export default __webpack_public_path__ + "static/media/wildsee_motel_lake.f2a8dabb.jpg";